import '@fontsource-variable/manrope';
import './src/app/styles/index.css';
import Wrapper from './wrapPageElement';

export const wrapPageElement = Wrapper;
